export class Schedule {

    private internalId: string;
    private relatedEntityInternalId: string;
    private mon: boolean;
    private tue: boolean;
    private wed: boolean;
    private thu: boolean;
    private fri: boolean;
    private sat: boolean;
    private sun: boolean;
    private openTimeMorning: number;
    private closeTimeMorning: number;
    private openTimeAfternoon: number;
    private closeTimeAfternoon: number;
    private startDate: number;
    private endDate: number;
    private openService: boolean;
    private commentNote: string;
    private timeZone: string;

    constructor(internalId?: string, relatedEntityInternalId?: string, mon?: boolean, tue?: boolean, wed?: boolean, thu?: boolean, fri?: boolean, sat?: boolean, sun?: boolean, openTimeMorning?: number, closeTimeMorning?: number, openTimeAfternoon?: number, closeTimeAfternoon?: number, startDate?: number, endDate?: number, openService?: boolean, commentNote?: string, timeZone?: string) {
        this.internalId = internalId;
        this.relatedEntityInternalId = relatedEntityInternalId;
        this.mon = mon;
        this.tue = tue;
        this.wed = wed;
        this.thu = thu;
        this.fri = fri;
        this.sat = sat;
        this.sun = sun;
        this.openTimeMorning = openTimeMorning;
        this.closeTimeMorning = closeTimeMorning;
        this.openTimeAfternoon = openTimeAfternoon;
        this.closeTimeAfternoon = closeTimeAfternoon;
        this.startDate = startDate;
        this.endDate = endDate;
        this.openService = openService;
        this.commentNote = commentNote;
        this.timeZone = timeZone;
    }

    public get InternalId() {
        return this.internalId;
    }
    public get RelatedEntityInternalId() {
        return this.relatedEntityInternalId;
    }
    public get Mon() {
        return this.mon;
    }
    public get Tue() {
        return this.tue;
    }
    public get Wed() {
        return this.wed;
    }
    public get Thu() {
        return this.thu;
    }
    public get Fri() {
        return this.fri;
    }
    public get Sat() {
        return this.sat;
    }
    public get Sun() {
        return this.sun;
    }
    public get OpenTimeMorning() {
        return this.openTimeMorning;
    }
    public get CloseTimeMorning() {
        return this.closeTimeMorning;
    }
    public get OpenTimeAfternoon() {
        return this.openTimeAfternoon;
    }
    public get CloseTimeAfternoon() {
        return this.closeTimeAfternoon;
    }
    public get StartDate() {
        return this.startDate;
    }
    public get EndDate() {
        return this.endDate;
    }
    public get OpenService() {
        return this.openService;
    }
    public get CommentNote() {
        return this.commentNote;
    }
    public get TimeZone() {
        return this.timeZone;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set RelatedEntityInternalId(relatedEntityInternalId) {
        this.relatedEntityInternalId = relatedEntityInternalId;
    }
    public set Mon(mon) {
        this.mon = mon;
    }
    public set Tue(tue) {
        this.tue = tue;
    }
    public set Wed(wed) {
        this.wed = wed;
    }
    public set Thu(thu) {
        this.thu = thu;
    }
    public set Fri(fri) {
        this.fri = fri;
    }
    public set Sat(sat) {
        this.sat = sat;
    }
    public set Sun(sun) {
        this.sun = sun;
    }
    public set OpenTimeMorning(openTimeMorning) {
        this.openTimeMorning = openTimeMorning;
    }
    public set CloseTimeMorning(closeTimeMorning) {
        this.closeTimeMorning = closeTimeMorning;
    }
    public set OpenTimeAfternoon(openTimeAfternoon) {
        this.openTimeAfternoon = openTimeAfternoon;
    }
    public set CloseTimeAfternoon(closeTimeAfternoon) {
        this.closeTimeAfternoon = closeTimeAfternoon;
    }
    public set StartDate(startDate) {
        this.startDate = startDate;
    }
    public set EndDate(endDate) {
        this.endDate = endDate;
    }
    public set OpenService(openService) {
        this.openService = openService;
    }
    public set CommentNote(commentNote) {
        this.commentNote = commentNote;
    }
    public set TimeZone(timeZone) {
        this.timeZone = timeZone;
    }
}
